var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import classnames from 'classnames';
import { propTypes } from './types';
var logoImg = require('../../assets/img/sonatype-logo-with-hexagon.png');
function HeaderLink(_a) {
    var name = _a.name, href = _a.href, current = _a.current;
    var classes = classnames('nx-page-header__link', {
        'nx-page-header__link--current': current
    });
    return (React.createElement("a", { className: classes, href: href, "data-text": name }, name));
}
// visible for testing
export { HeaderLink };
export default function NxPageHeader(_a) {
    var links = _a.links, homeLink = _a.homeLink, productInfo = _a.productInfo, children = _a.children;
    var logoEl = React.createElement("img", { src: logoImg, className: "nx-product__wordmark", alt: "\u2B21 Sonatype" }), linkEls = links && links.map(function (link) { return React.createElement(HeaderLink, __assign({ key: link.name }, link)); });
    return (React.createElement("header", { className: "nx-page-header" },
        React.createElement("div", { className: "nx-page-header__inner" },
            React.createElement("div", { className: "nx-product" },
                React.createElement("div", { className: "nx-product__branding" }, homeLink ? React.createElement("a", { className: "nx-product__home-link", href: homeLink }, logoEl) : logoEl),
                productInfo &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "nx-product__name" }, productInfo.name),
                        productInfo.version && React.createElement("div", { className: "nx-product__version" },
                            "Version: ",
                            productInfo.version))),
            linkEls && React.createElement("div", { className: "nx-page-header__links" }, linkEls),
            children && React.createElement("div", { className: "nx-page-header__extra-content" }, children))));
}
NxPageHeader.propTypes = propTypes;
//# sourceMappingURL=NxPageHeader.js.map